import { render, staticRenderFns } from "./PersonDownDispatches.vue?vue&type=template&id=355dd756&"
import script from "./PersonDownDispatches.vue?vue&type=script&lang=js&"
export * from "./PersonDownDispatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports